{
  "name": "backoffice",
  "version": "1.2.0-snapshot",
  "scripts": {
    "build": "ng build",
    "build:production": "ng build -c production",
    "start": "ng serve --watch",
    "start:local": "ng serve -c local --watch"
  },
  "private": true,
  "packageManager": "npm@11.12.1",
  "dependencies": {
    "@angular/cdk": "^22.0.2",
    "@angular/common": "^22.0.0",
    "@angular/compiler": "^22.0.0",
    "@angular/core": "^22.0.0",
    "@angular/forms": "^22.0.0",
    "@angular/material": "^22.0.2",
    "@angular/platform-browser": "^22.0.0",
    "@angular/router": "^22.0.0",
    "@ngrx/signals": "^21.1.1",
    "@ngx-dropzone/cdk": "^22.1.0",
    "angularx-qrcode": "^22.0.1",
    "lodash-es": "^4.18.1",
    "luxon": "^3.7.2",
    "ngx-infinite-scroll": "^22.0.0",
    "ngx-mask": "^22.1.0",
    "ngx-toastr": "^20.0.5",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular/build": "^22.0.4",
    "@angular/cli": "^22.0.4",
    "@angular/compiler-cli": "^22.0.0",
    "@tailwindcss/postcss": "^4.1.12",
    "@types/lodash-es": "^4.17.12",
    "@types/luxon": "^3.7.2",
    "jsdom": "^28.0.0",
    "postcss": "^8.5.3",
    "prettier": "^3.8.1",
    "tailwindcss": "^4.1.12",
    "typescript": "~6.0.2",
    "vitest": "^4.0.8"
  },
  "overrides": {
    "@ngrx/signals": {
      "@angular/common": "$@angular/common",
      "@angular/core": "$@angular/core"
    },
    "ngx-toastr": {
      "@angular/common": "$@angular/common",
      "@angular/core": "$@angular/core"
    }
  }
}
